module.exports = __webpack_public_path__ + "assets/5e8b32852824e0fbab545efa9dcba42d.png";